import { render, staticRenderFns } from "./CapturePicture.vue?vue&type=template&id=0f4415f0&"
import script from "./CapturePicture.vue?vue&type=script&lang=js&"
export * from "./CapturePicture.vue?vue&type=script&lang=js&"
import style0 from "./CapturePicture.vue?vue&type=style&index=0&id=0f4415f0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4415f0')) {
      api.createRecord('0f4415f0', component.options)
    } else {
      api.reload('0f4415f0', component.options)
    }
    module.hot.accept("./CapturePicture.vue?vue&type=template&id=0f4415f0&", function () {
      api.rerender('0f4415f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CapturePicture.vue"
export default component.exports